import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import SBDetailsPageActionButtons from '../components/SBDraftDetailsPageActions';
import SBInvoiceForm from '../../selfBilledInvoices/components/SBInvoiceForm';
import { useGetInvoiceHandler } from '../../Invoices/dataHandlers/getInvoiceHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBDraftInvoiceDetailsPage() {
  useDocumentTitle('Self Billed Invoice Details');
  const { document_id } = useParams();
  const navigate = useNavigate();
  const { invoice, isLoading } = useGetInvoiceHandler(document_id);
  if (isLoading || !invoice) {
    return <DocumentSkeletonForm />;
  }

  const handleBack = () => {
    navigate('/self-billed-drafts?tab=invoices');
  };

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      <Box sx={{ pb: 4 }}>
        <TopBar title="Invoice Details" subTitle={invoice?.document_id}>
          <SBDetailsPageActionButtons onBack={handleBack} />
        </TopBar>
      </Box>
      <SBInvoiceForm onSubmit={() => {}} onCancel={() => {}} initialData={invoice} readOnly={true} />
    </Stack>
  );
}
